export default __webpack_public_path__ + "static/media/Broadform-Homeowners-Key-Information-Document-April-2023.ce7efd45.pdf";